export enum PlanType {
  Basic,
  Advanced,
  Business,
  Enterprise,
}
